const transformReportFieldLabel = field => field.split('.')
  .map(part => part.charAt(0).toUpperCase() + part.slice(1))
  .join(': ')

export default transformReportFieldLabel
